export default "__VITE_ASSET__C63S4STO__"